import { createSelector } from 'reselect';
import { inEpisodeFlow } from '../../routes/state-management/selectors';
import { getDiscoverPublisher } from '../../discover/state-management/selectors';
import { isUserAnAdvertiser } from '../../../selectors/ui';
import { PUBLISHER_PRODUCT_LABEL } from '../constants';
import { IS_EMBEDDED } from '../../projects/constants';

export const getBuiltCreativeVersionId = (state) =>
  state.review.builtCreativeVersionId;
export const getEditionForCreative = (state) => state.review.editionForCreative;
export const getIsDownloadingComplete = (state) =>
  state.review.isDownloadingComplete;
export const getIsDownloadingEpisode = (state) =>
  state.review.isDownloadingEpisode;
export const getIsLoadingPublisherStories = (state) =>
  state.review.isLoadingPublisherStories;
export const getIsPublishingComplete = (state) =>
  state.review.isPublishingComplete;
export const getIsPublishingEpisode = (state) =>
  state.review.isPublishingEpisode;
export const getIsShowingReviewModal = (state) =>
  state.review.isShowingReviewModal;
export const getIsUpdatingEdition = (state) => state.review.isUpdatingEdition;
export const getIsUpdateEditionComplete = (state) =>
  state.review.isUpdateEditionComplete;
export const getIsZippingVideo = (state) => state.review.isZippingVideo;
export const getPublisherStories = (state) => state.review.publisherStories;
export const getSelectedPublisherStory = (state) =>
  state.review.selectedPublisherStory;
export const getUpdateEditionProgress = (state) =>
  state.review.updateEditionProgress;

export const getProductLabel = createSelector(
  [getDiscoverPublisher, inEpisodeFlow],
  (discoverPublisher, isInEpisodeFlow) => {
    if (!isInEpisodeFlow) {
      const isHappeningNowPublisher =
        discoverPublisher && discoverPublisher.isHappeningNowPublisher;
      return isHappeningNowPublisher
        ? PUBLISHER_PRODUCT_LABEL.DEFAULT
        : PUBLISHER_PRODUCT_LABEL.SIMPLE_OR_ADVANCED_MODE;
    }
    const isShowsPublisher =
      discoverPublisher && discoverPublisher.isShowsPublisher;
    return isShowsPublisher
      ? PUBLISHER_PRODUCT_LABEL.SHOW_PUBLISHER
      : PUBLISHER_PRODUCT_LABEL.DEFAULT;
  },
);

export const getIsReviewFlowEnabled = createSelector(
  [isUserAnAdvertiser],
  (isUserAnAdvertiser) => isUserAnAdvertiser || !IS_EMBEDDED,
);
